export const SALES_REP_TAB_CHALLENGES = 'challenges';
export const SALES_REP_TAB_QUIZ = 'quiz';
export const SALES_REP_TAB_USER = 'user';
